<template>
  <el-form
    :value="value"
  >
    <div class="row">
      <div class="col-3">
        <el-form-item
          prop="year"
          :label="L10n('year')"
          class="material-style"
        >
          <select-response
            :model.sync="value.year"
            @update:model="handlerFilter('year', $event)"
            :data="sourceYear"
            :clearable="false"
          />
        </el-form-item>
      </div>
    </div>
  </el-form>
</template>

<script>
export default {
  name: 'LayoutFilters',
  props: {
    value: { type: Object, required: true }
  },
  computed: {
    sourceYear () {
      let currentYear = new Date().getFullYear()
      let lastYear = 2019
      let result = []
      while (currentYear >= lastYear) {
        result.push({ id: currentYear, title: currentYear })
        currentYear--
      }
      return result
    }
  },
  methods: {
    handlerFilter (fieldName, value) {
      this.$emit('input', Object.assign({}, this.value, { [fieldName]: value }))
      this.$emit('on-filter')
    }
  }
}
</script>
